export default __webpack_public_path__ + "static/media/slider-3.997aacf7.jpg";